export default __webpack_public_path__ + "static/media/malaysia.6dbe3bfa.mp3";